module.exports = __webpack_public_path__ + "img/skull_11_bj.10dc92e8.png";